import { useRef, FC, useEffect, RefObject } from 'react';
import { useWindowSize } from 'src/hooks';

import { DropdownListItem } from 'components/molecules/PillFilters/PillFilters.types';

import styles from './DropDownWrapper.module.scss';

interface Props {
  dropDownItemSelected: (menutItem: DropdownListItem) => void;
  dropdownList: Array<DropdownListItem>;
  isMenuOpen: boolean;
  onDismiss: () => void;
  position: {
    x: number | null;
    y: number | null;
  };
}

const getBoundryOffSets = (
  position: { x: number | null; y: number | null },
  refOffsetWidth = 0,
  windowWidth: number
) => {
  // eslint-disable-next-line id-length
  const updateLocation = { x: position.x ?? 0, y: position.y ?? 0 };
  const dropdownContainerWidth = refOffsetWidth;
  if (updateLocation.x + dropdownContainerWidth > windowWidth) {
    // eslint-disable-next-line id-length
    updateLocation.x = windowWidth - dropdownContainerWidth;
  }
  return updateLocation;
};

export const DropDownWrapper: FC<Props> = ({
  children,
  dropdownList,
  isMenuOpen,
  position,
  dropDownItemSelected,
  onDismiss,
}) => {
  const { width: windowWidth } = useWindowSize();
  const targetRef = useRef<HTMLDivElement>(null);

  const useOutsideClickDismiss = (ref: RefObject<HTMLDivElement>, callback: () => void) => {
    useEffect(() => {
      const handleClickOutside = (event: Event) => {
        // @ts-expect-error should expect Event
        if (ref.current && !ref.current.contains(event.target)) {
          callback();
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    });
  };

  useOutsideClickDismiss(targetRef, onDismiss);

  return (
    <div className={styles['overlay-container']}>
      {children}
      {isMenuOpen && position.x && position.y && (
        <div
          className={styles['dropdown-list-container']}
          style={{
            left: getBoundryOffSets(position, targetRef.current?.offsetWidth, windowWidth).x,
            right: getBoundryOffSets(position, targetRef.current?.offsetWidth, windowWidth).y,
          }}
          ref={targetRef}
        >
          {dropdownList.map((data) => (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <div
              key={data.id}
              onClick={() => dropDownItemSelected(data)}
              className={styles['dropdown-list-item']}
            >
              {data.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default DropDownWrapper;
export type { Props as DropDownWrapperProps };
